<div class="container">
  <div class="header">
    <pdq-heading element="h3">Sync products</pdq-heading>
    <pdq-button (onClick)="onCancel()" variant="ghost" iconColor="var(--on-surface-light)" icon="close"></pdq-button>
  </div>
  <pdq-divider></pdq-divider>
  <div class="content">
    <pdq-radio-group variant="segmented" [value]="selectedMode()" (onChange)="selectedMode.set($event)">
      <pdq-radio-button text="From date" [value]="SyncProductsMode.FromDate"></pdq-radio-button>
      <pdq-radio-button text="Specific products" [value]="SyncProductsMode.SpecificProducts"></pdq-radio-button>
    </pdq-radio-group>
    @if (selectedMode() === SyncProductsMode.FromDate) {
      <div class="content__comment">Products created or updated since the selected date will be synced</div>
      <pdq-date-input
        label="Sync from"
        [formControl]="syncFromDateControl"
        [min]="earliestSyncFromDateIso"
        [max]="today"></pdq-date-input>
    } @else {
      <div class="content__comment">Only the listed products will be synced</div>
      <pdq-input
        label="Product IDs"
        placeholder="e.g. 8123456789, 8123456790"
        variant="form"
        [formControl]="productIdsControl"
        [invalid]="productIdsControl.dirty && productIdsControl.invalid"
        invalidMsg="Enter numeric product IDs separated by commas"></pdq-input>
    }
  </div>
  <pdq-divider></pdq-divider>
  <div class="footer">
    <pdq-button (onClick)="onCancel()" size="large" variant="light" label="Cancel"></pdq-button>
    <pdq-button
      [disabled]="
        selectedMode() === SyncProductsMode.FromDate ? syncFromDateControl.invalid : productIdsControl.invalid
      "
      (onClick)="onConfirm()"
      size="large"
      variant="primary"
      label="Sync"></pdq-button>
  </div>
</div>
